export var MediaType;
(function (MediaType) {
    MediaType["Image"] = "Image";
    MediaType["Video"] = "Video";
})(MediaType || (MediaType = {}));
